import { Card, Tabs, Tab } from "react-bootstrap";
import CustomButton from "../../components/CustomButton/CustomButton";
import { act, useEffect, useRef, useState } from "react";
import WebService from "../../utility/WebService";
import ReactQuill from "react-quill-new";
import { toast } from "react-toastify";
import { quillImageHandler } from "../../utility/quilImageHandler";
import CommonQuill from "../../components/editor/CommonQuill";

const WorkingGroup = () => {
  const [activeTab, setActiveTab] = useState<string>(
    "description"
    // localStorage.getItem("workingGroupTab") || "description"
  );
  const [description, setDescription] = useState("");
  const [descriptionId, setDescriptionId] = useState<string | null>(null);
  const quillRef = useRef<any>(null);
  const [pagePermission, setPagePermission] = useState({
    canView: false,
    canAdd: false,
    canEdit: false,
    canDelete: false,
  });
      const [customErrors, setCustomErrors] = useState<{
    description?: string;
  }>({});
  // ✅ Save tab selection in localStorage
  const handleTabChange = (key: string | null) => {
    const selectedTab = key || "description";
    setActiveTab(selectedTab);
    // localStorage.setItem("workingGroupTab", selectedTab);
  };

  // ✅ Load description or title list based on active tab
  useEffect(() => {
    console.log("activeTabbb", activeTab);
    if (activeTab === "description") {
      getDescription();
    }
  }, [activeTab]);

  const getDescription = () => {
    WebService.getAPI({
      action: "working-group/get-description-admin", // 👈 adjust API endpoint
    })
      .then((res: any) => {
        if (res?.data) {
          setDescription(res.data.description);
          setDescriptionId(res.data._id);
          const perm = res?.data?.permissions || {};

          console.log("l;og", perm);
          setPagePermission({
            canView: perm.canView,
            canAdd: perm.canAdd,
            canEdit: perm.canEdit,
            canDelete: perm.canDelete,
          });
        } else {
          setDescription("");
          setDescriptionId(null);
        }
      })
      .catch(() => {
        setDescription("");
        setDescriptionId(null);
      });
  };

  const saveDescription = () => {
    if (!description.trim()) {
      toast.error("Description is required");
      return;
    }

    if (descriptionId) {
      // ✅ Update existing description
      WebService.putAPI({
        action: `working-group/editDescription`,
        body: { description },
      })
        .then((res: any) => toast.success(res.message))
        .catch((err: any) =>
          toast.error(
            err.response?.data?.message || "Error updating description"
          )
        );
    } else {
      // ✅ Add new description
      WebService.postAPI({
        action: "working-group/addDescription",
        body: { description },
      })
        .then((res: any) => {
          toast.success(res.message);
          getDescription(); // refresh after save
        })
        .catch((err: any) =>
          toast.error(err.response?.data?.message || "Error saving description")
        );
    }
  };
  return (
    <>
      <div className="events-main">
        <Card className="event-card p-3">
          <div className="page-title">Working Group</div>
          <Tabs
            id="working-group-tabs"
            activeKey={activeTab}
            onSelect={handleTabChange}
            defaultActiveKey="description"
            className="mb-3"
          >
            {/* ✅ Description Tab */}
            <Tab eventKey="description" title="Description">
              <div>
                <CommonQuill
                  ref={quillRef}
                  value={description}
                  onChange={setDescription}
                  storage="ABOUT_US"
                  onClearError={() =>
                    setCustomErrors((p) => ({
                      ...p,
                      description: undefined,
                    }))
                  }
                />
                {customErrors.description && (
                  <div className="error-message">
                    {customErrors.description}
                  </div>
                )}
                {pagePermission.canAdd && (
                  <CustomButton
                    isLoading={false}
                    label="Save"
                    onClick={saveDescription}
                  />
                )}
              </div>
            </Tab>
          </Tabs>
        </Card>
      </div>
    </>
  );
};

export default WorkingGroup;
